var GOOGLE_MAPS_LIBRARIES, GOOGLE_MAPS_VERSION, GoogleMaps, MAP_PROXY_CHANNEL, MAP_PROXY_HOST_EU, MAP_PROXY_HOST_NA, callbacks, getMapProxyHost, loaded, loading;

MAP_PROXY_CHANNEL = 'layout-service';

MAP_PROXY_HOST_NA = '//mapproxy.groupon.com';

MAP_PROXY_HOST_EU = '//mapproxy-eu.groupon.com';

GOOGLE_MAPS_VERSION = 3;

GOOGLE_MAPS_LIBRARIES = ['geometry'];

loading = false;

callbacks = [];

loaded = function() {
  var cb, i, len, results;
  results = [];
  for (i = 0, len = callbacks.length; i < len; i++) {
    cb = callbacks[i];
    results.push(cb());
  }
  return results;
};

getMapProxyHost = function() {
  var country;
  country = document.head.getAttribute('data-country');
  if (country === 'US' || country === 'CL' || country === 'CO' || country === 'MX' || country === 'PA' || country === 'PE' || country === 'PR' || country === 'UY') {
    return MAP_PROXY_HOST_NA;
  } else {
    return MAP_PROXY_HOST_EU;
  }
};

module.exports = GoogleMaps = {
  load: function(cb) {
    var callbackName, query, ref;
    if (cb == null) {
      cb = function() {};
    }
    if (((ref = window.google) != null ? ref.maps : void 0) != null) {
      return cb();
    }
    callbacks.push(cb);
    if (loading) {
      return;
    }
    loading = true;
    callbackName = 'layoutServiceGoogleMapsCallback';
    window[callbackName] = loaded;
    query = $.param({
      sensor: false,
      v: GOOGLE_MAPS_VERSION,
      libraries: GOOGLE_MAPS_LIBRARIES.join(','),
      callback: callbackName,
      region: document.head.getAttribute('data-country') || 'US',
      language: document.head.getAttribute('data-lang') || 'en-US',
      channel: MAP_PROXY_CHANNEL
    });
    return $.getScript((getMapProxyHost()) + "/maps/api/js?" + query).fail(function() {
      return cb(new Error('Unable to load Google Maps Library'));
    });
  }
};

